import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { Text, Alert } from '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@grandvisionhq/locations';
import { ShippingMethodsList } from '../../modules/ShippingMethods/components/ShippingMethodsList.js';
import { ShippingMethodPlaceholder } from './components/ShippingMethodPlaceholder.js';
import { useGroupedShippingMethods } from './hooks/use-grouped-shipping-methods.js';

const AlternativeShippingMethodsList = ({ labels , onSubmit , onChange , onModalClose , selectedShippingMethod  })=>{
    const handleCompleted = ()=>{
        if (groupedShippingMethods.length === 0) {
            onSubmit();
        }
    };
    const { groupedShippingMethods , error , isLoading  } = useGroupedShippingMethods(selectedShippingMethod, handleCompleted);
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    const handleChange = (shippingMethodKey)=>{
        const shippingMethod = groupedShippingMethods.find((item)=>item.value === shippingMethodKey
        );
        onChange(shippingMethod);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "alternative-shipping-methods"
    }, isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary"
    }, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(ShippingMethodPlaceholder, null), /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "alternative-shipping-methods__button-placeholder"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "48px"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        rx: "4",
        height: "48px",
        fill: "currentColor"
    })))), error && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        title: labels.errorTitle
    }, labels.errorDescription), /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        caption: labels.back,
        onClick: onModalClose
    })), !isLoading && (groupedShippingMethods === null || groupedShippingMethods === void 0 ? void 0 : groupedShippingMethods.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.description), /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: handleChange,
        shippingMethodItems: groupedShippingMethods,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), /*#__PURE__*/ React.createElement(Button, {
        style: {
            width: '100%'
        },
        caption: labels.buttonCaptionLabel,
        onClick: onSubmit
    })));
};

export { AlternativeShippingMethodsList };
//# sourceMappingURL=AlternativeShippingMethodsList.js.map
